/** @jsx jsx */
import { jsx } from "@emotion/core";
import React, { useState, Suspense } from "react";
import { Switch, Route } from "react-router-dom";

import Drawer from "../components/Drawer";
import routes from "../routes";
import { content, contentExpanded } from "./styles";

const Layout = (): JSX.Element => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);

  return (
    <React.Fragment>
      <Drawer
        items={[
          {
            icon: "important-motifs",
            label: "Predict Important Motifs",
            path: "/important-motifs",
          },
          {
            icon: "stability-score",
            label: "Predict Stability Score",
            path: "/stability-score",
          },
          {
            icon: "similar-sequences",
            label: "Find Similarity Sequences",
            path: "/similar-sequences",
          },
        ]}
        open={isDrawerOpen}
        onToggle={(): void => setIsDrawerOpen(!isDrawerOpen)}
      />
      <div css={isDrawerOpen ? content : contentExpanded}>
        <Suspense fallback={(): JSX.Element => <h2>Loading...</h2>}>
          <Switch>
            {routes?.map((route, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <Route key={i} {...route} />
            ))}
          </Switch>
        </Suspense>
      </div>
    </React.Fragment>
  );
};

export default Layout;
